import React from 'react';
import {
  HashRouter as Router,
  Switch,
  Route,
} from "react-router-dom";

import { GraphqlProvider } from "./graphql";

import AdminRoute from './components/common/AdminRoute'
import PrivateRoute from './components/common/PrivateRoute'
import GenPdfRoute from './components/common/GenPdfRoute'

import Home from './components/Home'
import Explain from './components/Explain'
import Login from './components/Login'
import DownloadBadge from './components/DownloadBadge'
import Badge from './components/Badge'


import AdminHome from './components/admin/Home'
import AdminLogin from './components/admin/Login'

const App = () => {
  return (
    <GraphqlProvider>
      <Router>
        <Switch>
          <Route exact path="/explain" component={Explain} />
          <Route exact path="/login" component={Login} />
          <GenPdfRoute exact path="/download/badges/:badgeId" component={DownloadBadge} />
          <GenPdfRoute exact path="/badges/:badgeId" component={Badge} />
          <Route exact path="/admin/login" component={AdminLogin} />
          <AdminRoute path="/admin" fallbackPath="/admin/login">
            <Switch>
              <Route exact path="/admin" component={AdminHome} />
            </Switch>
          </AdminRoute>
          <PrivateRoute fallbackPath="/explain">
            <Switch>
              <Route exact path="/" component={Home} />
            </Switch>
          </PrivateRoute>
        </Switch>
      </Router>
    </GraphqlProvider>
  );
}

export default App;
